var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("preloader", { attrs: { display: _vm.loading } })
    : _c(
        "div",
        { staticClass: "overview-v3" },
        [
          _c("div", { staticClass: "overview-v3__subscription-summary" }, [
            _c(
              "div",
              { staticClass: "overview-v3__subscription-summary__information" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "overview-v3__subscription-summary__information-plan"
                  },
                  [
                    _c("p", [
                      _c(
                        "span",
                        { staticClass: "typographies-paragraph-medium-bold" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Nombre d’utilisateurs")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.staffsNumber) +
                              "\n                    "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "span",
                        { staticClass: "typographies-paragraph-medium-bold" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Dates d'abonnement")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.subscriptionDataHumanized) +
                              "\n                    "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "span",
                        { staticClass: "typographies-paragraph-medium-bold" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Type d'abonnement")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.subscriptionType) +
                              "\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.edit_subscription")
                  },
                  on: { click: _vm.upsellCart }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overview-v3__subscription-summary__manager" },
              [
                _c("h3", { staticClass: "typographies-heading-h3" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Gérer mon abonnement")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.actions, function(action) {
                  return _c(
                    "div",
                    {
                      key: action.section,
                      staticClass: "manage-chargebee-account__container-btn"
                    },
                    [
                      _c("CompassPlainButton", {
                        attrs: { label: action.labelBtn },
                        on: {
                          click: function($event) {
                            return _vm.openCbPortalSection(action.section)
                          }
                        }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("ChargebeeSubscriptionOverviewPluginsV3", {
            attrs: {
              subscriptionItems: _vm.subscriptionChargebee.subscription_items
            }
          }),
          _vm._v(" "),
          _c("QuotaSummary", {
            attrs: {
              "is-chargebee-provider": true,
              "chargebee-third-party-payer-id": _vm.chargebeeThirdPartyPayerId,
              "license-assignement": _vm.licenseAssignement
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }